import { CompanyDocumentBasicModel, CompanyDocumentContentModel, CompanyDocumentContentSectionModel, CompanyDocumentModel, CompanyDocumentSimplifiedModel } from "@shared/models";
import { FormatDatesService } from "@shared/services";

interface CompanyDocumentContentPageModel {
  read?:     boolean;
  collapse?: boolean;
  content:   CompanyDocumentContentSectionModel[];
}

export class CompanyDocumentBasic {
  id:            number;
  title:         string;
  type:          string;

  coverImageUrl: string;
  coverImage:    string;

  version:       string;
  versionDate:   Date;

  createdAt:     Date;
  confirmedAt:   Date;
  constructor(data: CompanyDocumentBasicModel) {
    this.id            = data.id      ? data.id      : null;
    this.title         = data.title   ? data.title   : null;
    this.type          = data.type    ? data.type    : null;

    this.version       = data.version ? data.version : null;
    this.versionDate   = FormatDatesService.parseDate(data.version_date);

    this.createdAt     = FormatDatesService.parseDate(data.created_at);
    this.confirmedAt   = FormatDatesService.parseDate(data.confirmed_at);
  }

  toJSON(): CompanyDocumentBasicModel {
    return {
      id:           this.id      ? this.id      : null,
      title:        this.title   ? this.title   : null,
      type:         this.type    ? this.type    : null,

      version:      this.version ? this.version : null,
      version_date: FormatDatesService.parseDateISO(this.versionDate),

      created_at:   FormatDatesService.parseDateISO(this.createdAt),
      confirmed_at: FormatDatesService.parseDateISO(this.confirmedAt)
    };
  }

}

export class CompanyDocumentSimplified extends CompanyDocumentBasic {
  coverImageUrl: string;
  coverImage:    string;
  constructor(data: CompanyDocumentSimplifiedModel, banner: string) {
    super(data);
    this.coverImageUrl = data.cover_image_url       ? data.cover_image_url       : null;
    this.coverImage    = banner || data.cover_image ? banner || data.cover_image : null;
  }

  toJSON(): CompanyDocumentSimplifiedModel {
    return Object.assign(super.toJSON(), {
      cover_image_url: this.coverImageUrl ? this.coverImageUrl : null,
      cover_image:     this.coverImage    ? this.coverImage    : null,
    });
  }

}

export class CompanyDocument extends CompanyDocumentBasic {
  content: CompanyDocumentContentModel;
  pages:   CompanyDocumentContentPageModel[];
  constructor(data: CompanyDocumentModel) {
    super(data);
    this.content = data.content ? data.content : null;
    this.pages   = this.mapPages();
  }

  private mapPages(): CompanyDocumentContentPageModel[] {
    let pages: any = {};
    this.content?.sections?.forEach(s => {
      if (!pages[s.page]) pages[s.page] = { content: [] };
      pages[s.page].content.push(s);
    });
    return Object.values(pages);
  }

  toJSON(): CompanyDocumentModel {
    return Object.assign(super.toJSON(), {
      content: this.content ? this.content : null,
    });
  }

}
